import axios from "axios";

export default class messengerService {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getGroups(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/chat/cms`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getGroupsById(id) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/chat/group/${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async downloadGroupsTable(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/chat/cms`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteGroupImage(params) {
    try {
      const response = await axios({
        method: "delete",
        url: `${this.API_LINK}/chat/cms`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
